import { ACCESS_TOKEN } from "../constants/global";
import Cookies from "js-cookie";
import { getHostedDomain } from "./getHostedDomain";

export const setAccessToken = (token: string): string | undefined =>
  Cookies.set(ACCESS_TOKEN, token, { domain: getHostedDomain() });
